import api from "../index";
import { apiUrl, constant } from "../../utils/constants";

export const GetDepartments = (params) => api.get(`${constant.V1}${apiUrl.departments}/`, { params })
export const GetSingleDepartment = (id) => api.get(`${constant.V1}${apiUrl.departments}/${id}`)
export const GetDepartmentsBySite = (id, params) => api.get(`${constant.V1}${apiUrl.sites}/${id}${apiUrl.departments}/`, { params })

